import React, { useEffect, useState } from 'react';

const SignInWithPCCButton = () => {
  const clientId = process.env.REACT_APP_PCC_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_PCC_REDIRECT_URI;
  const [isAuthenticatedWithPCC, setIsAuthenticatedWithPCC] = useState(false);

  useEffect(() => {
    // Check if the user already has a PCC token/session
    const token = sessionStorage.getItem('pcc_accessToken');
    const orgUuid = sessionStorage.getItem('pcc_orgUuid');
    const pccUserId = sessionStorage.getItem('pcc_userId');

    if (token && orgUuid && pccUserId) {
      setIsAuthenticatedWithPCC(true);
    }
  }, []);

  const state = crypto.randomUUID();

  const handleLogin = () => {
    sessionStorage.setItem('pcc_auth_state', state);
    const url = `https://connect.pointclickcare.com/auth/login?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&scope=openid&state=${state}`;
    window.location.href = url;
  };

  if (isAuthenticatedWithPCC) {
    return null; // 🚫 Don't show the button if already logged in with PCC
  }

  return (
    <button
      onClick={handleLogin}
      className="flex items-center gap-2 p-3 bg-blue-600 text-white rounded hover:bg-blue-700"
    >
      <img src="/pcc-logo.svg" alt="PCC Logo" className="h-6 w-auto" />
    </button>
  );
};

export default SignInWithPCCButton;
